import {
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList,
  GraphQLFieldConfig
} from 'graphql'
import {
  CompliancePolicy,
  CompliancePolicyType as compliancePolicyType
} from '../types/compliance-policy'

const responseType = new GraphQLObjectType({
  name: 'CompliancePolicies',
  description: 'Compliance Policies list',
  fields: () => ({
    policies: {
      type: new GraphQLNonNull(new GraphQLList(compliancePolicyType))
    }
  })
})

interface Policies {
  readonly policies: CompliancePolicy[]
}

interface Context {
  readonly connector: {
    readonly get: (url: string) => Promise<any>
  }
}

interface Args {
  readonly organizationID: string
}

export const compliancePolicies: GraphQLFieldConfig<undefined, Context, Args> =
  {
    description: 'Get the enabled compliance policies for an organization',
    type: new GraphQLNonNull(responseType),
    args: {
      organizationID: {
        description: 'The unique ID for the organization being queried',
        type: new GraphQLNonNull(GraphQLID)
      }
    },
    async resolve(_source, args, context): Promise<Policies> {
      const { organizationID } = args

      const { policies } = await context.connector.get(
        `${organizationID}/policy/compliance`
      )

      return {
        policies: policies.map(({ name, policy_id: id, enabled, key }) => ({
          name,
          id,
          enabled,
          key
        }))
      }
    }
  }
